import React, { PureComponent } from 'react';
import { connect } from 'unistore/react';
import styled, { css } from 'styled-components';
import { Flex, Box } from 'rebass';

import { groupedOptionsSelector } from '~/state/Selectors';
import Actions from '~/state/Actions';
import { parseLabel } from '~/Utils';

const PresetButtonsWrapper = styled.div`
  font-size: 14px;
`;

const PresetButton = styled.button`
  padding: 5px;
  margin: 3px;
  flex-shrink: 0;
  cursor: pointer;
  font-size: 14px;
  display: block;
  padding: 8px 15px;
  border: 1px solid rgb(221, 221, 221);
  background: rgb(238, 238, 238);
  outline: none;
  color: #999;

  ${(props) =>
    props.isActive
      ? css`
          background: ${(props) => props.theme.colors.blue};
          color: white;
          border-color: ${(props) => props.theme.colors.blue};
          font-weight: bold;
        `
      : ''}

  &:hover {
    background: ${(props) => props.theme.colors.blue};
    color: white;
  }
`;

const HiddenFakeLabel = styled.span`
  display: block;
  height: 0px;
  overflow: hidden;
  font-size: 14px;
  font-weight: bold;
  opacity: 0;
  visibility: hidden;
`;

const GroupLabel = styled(Box)`
  text-transform: uppercase;
  font-size: 12px;
`;

const MainLabel = styled(GroupLabel)`
  text-transform: none;
  font-size: 14px;
  margin-bottom: 5px;
  font-weight: bold;
`;

const Option = connect(
  'compareKey',
  Actions
)(({ value, label, setCompareKey, compareKey }) => (
  <PresetButton
    isActive={compareKey === value}
    onClick={() => setCompareKey(value)}
    key={value}
  >
    {parseLabel(label)}
    <HiddenFakeLabel>{label}</HiddenFakeLabel>
  </PresetButton>
));

const OptGroup = ({ label, value, options }) => {
  const buttons = options ? (
    options.map((opt) => <Option key={opt.label} {...opt} />)
  ) : (
    <Option key={value} label={label} value={value} />
  );

  return (
    <div>
      {options && (
        <GroupLabel mt={3} mb="3px">
          {label}
        </GroupLabel>
      )}
      <Flex flexWrap="wrap" mx="-3px">
        {buttons}
      </Flex>
    </div>
  );
};

class PresetButtons extends PureComponent {
  render() {
    const { options } = this.props;

    return (
      <PresetButtonsWrapper>
        <MainLabel>
          Wählen Sie eine Vergleichsgruppe (rechte Seite der Grafik):
        </MainLabel>
        {options.map((optGroup) => (
          <OptGroup key={optGroup.label} {...optGroup} />
        ))}
      </PresetButtonsWrapper>
    );
  }
}

export default connect((state) => ({
  options: groupedOptionsSelector(state),
}))(PresetButtons);
